var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"invalid_page"}},[_c('test')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }